import React from 'react';
import { Icons } from '../../../components/atoms/SVG';
import {
  BlockInteractions,
  createButtonObject,
  DISPLAY_TYPE,
  Views as BlockInteractionsViews,
} from '../../../components/organisms/BlockInteractions';
import { Namespace } from '../../../translation/namespace';
import { DefaultView, DeleteAction, OptionalEditView, Views } from '../../../types/BlockWithViews';
import { useBlockContext, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useContentWrapperContext } from '../../../components/blocks/ContentWrapper/ContentWrapperContext';
import { useContentWrapperDndContext } from '../../../components/blocks/ContentWrapper/ContentWrapperDndProvider';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { PdfFileDetailsEditView } from '../views/PdfFileDetailsEditView';
import {
  ExternalContentDefaultViewProps,
} from '../../../_lib/components/ExternalContent/views/ExternalContentDefaultView';
import {
  ExternalContentEditDefaultView,
} from '../../../_lib/components/ExternalContent/views/ExternalContentEditDefaultView';
import { headlineHierarchy } from '../../../components/organisms/BlockInteractions/BlockInteractions.utils';

export type PdfFileDetailsBlockProps = Views<
  DefaultView<ExternalContentDefaultViewProps> & OptionalEditView<PdfFileDetailsEditView> & DeleteAction
>;

export function PdfFileDetailsInteractions({ views, activeView = 'default' }: PdfFileDetailsBlockProps) {
  const { t } = useSonTranslation('PdfFileDetails');
  const { uuid, elementType } = useBlockContext();
  const { refresh, refreshCount } = useRefreshBlock();
  const contentWrapperContext = useContentWrapperContext();
  const contentWrapperDndContext = useContentWrapperDndContext();

  const buttons = {
    ...(views.edit &&
      createButtonObject(
        BlockInteractionsViews.EDIT,
        Icons.EDIT_PENCIL,
        `${Namespace.PdfFileDetails}:edit`,
        DISPLAY_TYPE.COLLAPSIBLE,
        <PdfFileDetailsEditView {...views.edit} />,
      )),
    ...(views.delete &&
      createButtonObject(
        BlockInteractionsViews.DELETE,
        Icons.ERASER,
        `${Namespace.PdfFileDetails}:delete`,
        DISPLAY_TYPE.MODAL,
        null,
      )),
  };

  return (
    <BlockInteractions
      uuid={uuid}
      elementType={elementType}
      headline={{
        text: t('headline'),
        hierarchy: headlineHierarchy(2, contentWrapperContext?.parentIndex, contentWrapperContext?.grandParentIndex),
        visible: true,
      }}
      views={views}
      activeView={activeView}
      buttons={buttons}
      contentWrapperContext={contentWrapperContext}
      contentWrapperDndContext={contentWrapperDndContext}
      refreshBlock={refresh}
      refreshCount={refreshCount}
    >
      <ExternalContentEditDefaultView {...views.default} />
    </BlockInteractions>
  );
}
